import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Switch } from "./ui/switch";

export default function OfferNotifyPrefs() {
  const { user, refresh } = useAuth();
  const [cats, setCats] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/categories").then(({ data }) => setCats(data)).catch(() => {}); }, []);
  const enabled = user?.offers_notifications !== false;
  const selected = user?.offer_notify_categories || [];
  const save = async (patch) => {
    setBusy(true);
    try { await api.patch("/auth/me", patch); await refresh(); toast.success("Preferenze notifiche salvate"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const toggleCat = (id) => save({ offer_notify_categories: selected.includes(id) ? selected.filter(c => c !== id) : [...selected, id] });
  return (
    <div className="ga-card p-5" data-testid="offer-notify-prefs">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1.5"><BellRing className="w-3.5 h-3.5" /> Notifiche offerte fornitori</div>
          <div className="mt-1 text-sm text-slate-600">Ricevi un avviso quando un fornitore della tua zona pubblica un lotto in offerta.</div>
        </div>
        <Switch checked={enabled} disabled={busy} onCheckedChange={(v) => save({ offers_notifications: v })} data-testid="offer-notify-switch" />
      </div>
      {enabled && (
        <div className="mt-3">
          <div className="text-xs text-slate-500 mb-2">{selected.length === 0 ? "Nessuna categoria selezionata: ti avvisiamo per le categorie che hai ordinato negli ultimi 90 giorni e per i tuoi fornitori preferiti." : "Ti avvisiamo solo per le categorie selezionate:"}</div>
          <div className="flex flex-wrap gap-2">
            {cats.map(c => {
              const on = selected.includes(c.id);
              return <button key={c.id} type="button" disabled={busy} onClick={() => toggleCat(c.id)} className={`rounded-full px-3 py-1 text-xs font-semibold border transition ${on ? "bg-emerald-600 text-white border-emerald-700" : "border-slate-300 text-slate-700 hover:bg-slate-50"}`} data-testid={`offer-notify-cat-${c.id}`} aria-pressed={on}>{c.label}</button>;
            })}
          </div>
        </div>
      )}
    </div>
  );
}
